import { render } from "./ChatInfo.vue?vue&type=template&id=35f77b9e"
import script from "./ChatInfo.vue?vue&type=script&lang=js"
export * from "./ChatInfo.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__